import React from 'react';
import styled from 'styled-components';

const BackgroundWrapper = styled.div`
    position: fixed;
    inset: 0;
    z-index: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
`;

/**
 * Shared dot-grid background (dark base #05080D + dot pattern #1e293b).
 * Used by new-home and dashboard pages.
 */
const DotGridBackground = ({ as: Component = BackgroundWrapper, ...props }) => (
    <Component aria-hidden {...props}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            style={{ display: 'block' }}
        >
            <defs>
                <pattern
                    id="dot-grid-pattern"
                    width="24"
                    height="24"
                    patternUnits="userSpaceOnUse"
                >
                    <circle cx="2" cy="2" r="0.9" fill="#1e293b" />
                </pattern>
            </defs>
            <rect width="100%" height="100%" fill="#05080D" />
            <rect width="100%" height="100%" fill="url(#dot-grid-pattern)" />
        </svg>
    </Component>
);

export default DotGridBackground;
